import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { view } from "@risingstack/react-easy-state";
import _ from "lodash";
import PRODUCT_PLACEHOLDER from "../../assets/images/product_placeholder.png";
import { PRODUCT_TITLE, UPLOAD_CAPTION } from "../styles";

const ItemCard = (props: any) => {
  const { data, handleProductClick } = props;

  const getItemTitle = (titles: any[]) => {
    if (_.isEmpty(titles) || titles.length === 0) {
      return "";
    }
    return titles.slice(0, 1);
  };

  const getBrand = (item: any) => {
    if (item) {
      return item.brand ? item.brand : "";
    }
    return "";
  };

  const getImageUrl = (urls: any) => {
    if (_.isEmpty(urls) || urls.length === 0) {
      return PRODUCT_PLACEHOLDER;
    }
    return urls ? urls[0] : "";
  };
  return (
    <Card
      style={{
        width: 250,
        height: 320,
        marginBottom: 16,
        marginRight: 16,
        ...props.style,
      }}
      sx={{
        background: "#FFFFFF",
        borderRadius: "8px",
        cursor: "pointer",
      }}
      onClick={handleProductClick}
    >
      <CardMedia
        sx={{ height: 205, backgroundSize: "contain" }}
        image={getImageUrl(data?.imageUrls)}
        title={data?.upc}
        src={"img"}
      />
      <CardContent>
        <Typography sx={PRODUCT_TITLE}>{getBrand(data)}</Typography>
        <Typography sx={UPLOAD_CAPTION}>
          {getItemTitle(data?.titles)}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default view(ItemCard);
